import { useEffect } from 'react';

import { userManager } from '@/lib/fusionauth';
import { useSignUpReferralStore } from '@/stores/signup-referral.store';
import { useSignUpStore } from '@/stores/signup.store';
import { useUserStore } from '@/stores/user.store';

const LogoutPage = () => {
  useEffect(() => {
    (async () => {
      const store = useUserStore.getState();
      store.setUser(null);
      store.setOrg(null);
      useSignUpStore.getState().clearSignUpStore();
      useSignUpReferralStore.getState().clearSignUpReferral();

      userManager.signoutRedirect({
        post_logout_redirect_uri: window.location.origin,
      });
    })();
  }, []);

  return <>Logging out...</>;
};

export default LogoutPage;
